export default __webpack_public_path__ + "static/media/ic-radar.f26ea06c.svg";